const config = {
  "repair booked": {
    liveChatLocation: "repairs-electrical | repair | booked",
    analyticsPageName: ":repairs:repair-booked",
    currentStatus: "repair booked",
  },
  "repair in progress": {
    liveChatLocation: "repairs-electrical | repair | in-progress",
    analyticsPageName: ":repairs:repair-in-progress",
    currentStatus: "repair in progress",
  },
  "repair in progress - awaiting information from the customer": {
    liveChatLocation: "repairs-electrical | repair | waiting-on-customer",
    analyticsPageName: ":repairs:repair-waiting-on-customer",
    currentStatus: "repair in progress",
  },
  "repair in progress - awaiting parts": {
    liveChatLocation: "repairs-electrical | repair | awaiting-parts",
    analyticsPageName: ":repairs:repair-awaiting-parts",
    currentStatus: "repair in progress",
  },
  "on its way back": {
    liveChatLocation: "repairs-electrical | repair | on-way-back",
    analyticsPageName: ":repairs:repair-on-way-back",
    currentStatus: "on its way back",
  },
  "ready for collection": {
    liveChatLocation: "repairs-electrical | repair | ready-for-collection",
    analyticsPageName: ":repairs:repair-ready-for-collection",
    currentStatus: "ready for collection",
  },
  "repair completed": {
    liveChatLocation: "repairs-electrical | repair | completed",
    analyticsPageName: ":repairs:repair-completed",
    currentStatus: "repair completed",
  },
  "please contact us": {
    liveChatLocation: "repairs-electrical | repair | cancelled",
    analyticsPageName: ":repairs:repair-cancelled",
    currentStatus: "please contact us",
  },
  unknown: {
    liveChatLocation: "repairs-electrical | repair | unknown",
    analyticsPageName: ":repairs:repair-unknown",
    currentStatus: "unknown",
  },
};
const getCallStatusConfig = key => config[key?.toLowerCase()];

export default getCallStatusConfig;
